module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAJhJREFUWEftlsENgCAMRbUDNYyAk6mTyQikA6FpAgka1EMT8fA58kn7+9oA49B5jZ3zDzAAAiAAAiDwbwLOOZ9S8iKytN4Mq64xbwkw814nFZHTWateYjcNMLNWPNcGiGiKMQbds+p13KaBjHa7YF9LK6z6q4FcZb8WFIeKmohCQX8dRKv+OIRf/ZT+fQ98QQEEQAAEQAAEDlDdYyE9EJB3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/three-points.png
// module id = Zol/
// module chunks = 1